export default __webpack_public_path__ + "static/media/SndLowerPSwimUpOver.e7ab1cc5.mp3";